export const CATEGORIES = 'categories/withProducts';

export class CategoriesDto {
  id: number;
  // createdAt: string;
  // updatedAt: string;
  // hash: string;
  name: string;
  code: number;
  // hierarchyName: string;
  fatherCode: number;
}
